var map = {
	"./brand.svg": 817,
	"./business-card.svg": 8799,
	"./category.svg": 9842,
	"./dashboard.svg": 4298,
	"./department.svg": 9612,
	"./goods.svg": 9772,
	"./material.svg": 1425,
	"./menu-ad.svg": 8155,
	"./menu-member.svg": 7218,
	"./menu-order.svg": 1356,
	"./new.svg": 7624,
	"./opm.svg": 5708,
	"./permission.svg": 1707,
	"./position.svg": 979,
	"./recommend.svg": 1556,
	"./role.svg": 2578,
	"./sale-category.svg": 424,
	"./shop.svg": 2494,
	"./spu.svg": 2592,
	"./staff.svg": 9412,
	"./tree.svg": 4110,
	"./un-new.svg": 5514,
	"./un-recommend.svg": 1222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2403;